import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LogoFacebook = function LogoFacebook(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, newProps), {}, {
    className: classNames('sol-illustration', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "logo.facebook"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "logo-facebook"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    d: "M22.8585 1.0061L19.1552 1C14.9946 1 12.3059 3.83312 12.3059 8.21814V11.5462H8.58231C8.26056 11.5462 8 11.8141 8 12.1446V16.9665C8 17.297 8.26085 17.5646 8.58231 17.5646H12.3059V29.7319C12.3059 30.0623 12.5664 30.33 12.8882 30.33H17.7464C18.0681 30.33 18.3286 30.062 18.3286 29.7319V17.5646H22.6823C23.0042 17.5646 23.2647 17.297 23.2647 16.9665L23.2665 12.1446C23.2665 11.9859 23.205 11.8339 23.096 11.7216C22.9869 11.6094 22.8383 11.5462 22.6838 11.5462H18.3286V8.72496C18.3286 7.36897 18.6433 6.6806 20.3632 6.6806L22.8579 6.67968C23.1794 6.67968 23.44 6.41178 23.44 6.08162V1.60416C23.44 1.27431 23.1797 1.00671 22.8585 1.0061Z",
    fill: "#4267B2"
  }))));
};

export { LogoFacebook };
